export const DEFAULT_SURVEY_PERIOD_DAYS = 30;

export function formatSurveyDateInput(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function getDefaultSurveyPeriod(days = DEFAULT_SURVEY_PERIOD_DAYS) {
  const end = new Date();
  end.setHours(0, 0, 0, 0);
  const start = new Date(end);
  start.setDate(start.getDate() - Math.max(0, days - 1));
  return {
    startDate: formatSurveyDateInput(start),
    endDate: formatSurveyDateInput(end),
    days,
  };
}

export function isFullHistoryPeriod(startDate, endDate) {
  return !String(startDate || "").trim() && !String(endDate || "").trim();
}

export function matchesDefaultSurveyPeriod(startDate, endDate, days = DEFAULT_SURVEY_PERIOD_DAYS) {
  const defaults = getDefaultSurveyPeriod(days);
  return startDate === defaults.startDate && endDate === defaults.endDate;
}

export function buildSurveyPeriodFilters(startDate, endDate) {
  if (isFullHistoryPeriod(startDate, endDate)) {
    return {};
  }
  return {
    startDate: startDate || undefined,
    endDate: endDate || undefined,
  };
}

export function isCompleteSurveyDateInput(value) {
  const str = String(value || "").trim();
  if (!str) return true;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return false;
  const [y, m, d] = str.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}

export function resolveSurveyPeriodFilters(startDate, endDate, fallback = null) {
  if (!isCompleteSurveyDateInput(startDate) || !isCompleteSurveyDateInput(endDate)) {
    return fallback;
  }
  return buildSurveyPeriodFilters(startDate, endDate);
}
